import React from "react";
import { Button as MuiButton } from "@mui/material";
import { color, styled } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";

interface ButtonProps {
  label: string;
  variant?: "primary" | "secondary";
  variantType?: "contained" | "outlined";
  onClick?: () => void;
  isLoading?: boolean;
  style?: any;
  type?: any;
  disabled?: boolean;
}

const StyledButton = styled(MuiButton)<{
  buttonvariant: "primary" | "secondary";
  buttontype: "contained" | "outlined";
}>((props) => {
  const { theme, buttonvariant, buttontype } = props;
  return {
    textTransform: "none",
    padding: "8px 16px",
    height: "50px",
    minWidth: 110,
    fontSize: (theme.typography as any)?.fontSize || "1rem",
    borderRadius: "5px",
    ...(buttonvariant === "primary" &&
      buttontype === "contained" && {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
      }),
    ...(buttonvariant === "primary" &&
      buttontype === "outlined" && {
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      }),
    ...(buttonvariant === "secondary" &&
      buttontype === "contained" && {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
        "&:hover": {
          backgroundColor: theme.palette.secondary.dark,
        },
      }),
    ...(buttonvariant === "secondary" &&
      buttontype === "outlined" && {
        color: theme.palette.secondary.main,
        border: `1px solid ${theme.palette.secondary.main}`,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      }),
    "&.Mui-disabled": {
      backgroundColor: "#E0E0E0",
      color: "#9E9E9E",
      border: "none",
      cursor: "not-allowed",
    },
    "@media (max-width: 600px)": {
      height: "40px",
      minWidth: "90px",
    },
  };
});

const Button: React.FC<ButtonProps> = ({
  label,
  variant = "primary",
  variantType = "contained",
  onClick,
  isLoading = false,
  style,
  type = "button",
  disabled = false,
}) => {
  return (
    <StyledButton
      type={type}
      buttonvariant={variant}
      buttontype={variantType}
      onClick={onClick}
      disabled={isLoading || disabled}
      style={{ ...style }}
    >
      {isLoading ? (
        <CircularProgress
          size={18}
          style={{
            color:
              variant === "primary" && variantType === "contained"
                ? "#fff"
                : variant === "primary" && variantType === "outlined"
                ? "#fb8b0e"
                : variant === "secondary" && variantType === "contained"
                ? "#fff"
                : "#034ea2",
          }}
        />
      ) : (
        label
      )}
    </StyledButton>
  );
};

export default Button;
